var app = angular.module("leonardo");

var HeadController = function($scope, ConfigThemeService, $timeout) {

  $scope.theme_config = ConfigThemeService;

  angular.element(document).ready(function() {
    document.title = ConfigThemeService.config.name;
  });

  $scope.$on('white-label:update-theme', function(){
    $timeout(function () {
      angular.element(document).attr('title', ConfigThemeService.config.name);
    });
  });

};

app.controller('HeadController', ['$scope', 'ConfigThemeService', '$timeout', HeadController]);
